import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postMemberAttendance = ({ attendanceId, data }) => {
  return api.post(`/admin/member-attendance/${attendanceId}`, data);
};

export const usePostMemberAttendanceMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postMemberAttendance,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
